import Vue from 'vue';
import { mapState, mapActions } from 'pinia';
import countlyCommon from './countly.common';
import useModalClientsStore from '../lib-components/modal/store';

let uniqueComponentId = 0;

const countlyBaseComponent = Vue.extend({
  computed: {
    componentId() {
      return `cly-cmpl-${uniqueComponentId}`;
    },
  },
  beforeCreate() {
    this.ucid = uniqueComponentId.toString();
    uniqueComponentId += 1;
  },
});

const components = {
  BaseComponent: countlyBaseComponent,
};

const BaseContentMixin = countlyBaseComponent.extend(
  // @vue/component
  {
    inheritAttrs: false,
    props: {
      name: { type: String, default: null },
      id: { type: String, default: null },
      alwaysMounted: { type: Boolean, default: true },
      alwaysActive: { type: Boolean, default: false },
      role: { type: String, default: 'default' },
    },
    data() {
      return {
        isContent: true,
      };
    },
    computed: {
      isActive() {
        return this.alwaysActive || (this.role === 'default' && this.$parent.activeContentId === this.id);
      },
      tName() {
        return this.name;
      },
      tId() {
        return this.id;
      },
      elementId() {
        return `${this.componentId}-${this.id}`;
      },
    },
  },
);

export default {
  components,
  mixins: {
    commonFormatters: {
      methods: {
        parseTimeAgo: countlyCommon.formatTimeAgoText,
        formatTimeAgo: countlyCommon.formatTimeAgo,
        formatNumber: countlyCommon.formatNumber,
        formatNumberSafe: countlyCommon.formatNumberSafe,
        getShortNumber: countlyCommon.getShortNumber,
      },
    },
    Modal: {
      computed: {
        ...mapState(useModalClientsStore, ['nClients']),
      },
      methods: {
        ...mapActions(useModalClientsStore, ['setState']),
        setModalState(state) {
          this.setState(this.componentId, state);
        },
      },
      beforeDestroy() {
        this.setState(this.componentId, false);
      },
    },
    BaseContent: BaseContentMixin,
  },
};
